@if (action() === 'subscribe') {
  <a
    class="btn-primary btn flex w-full gap-1 md:w-auto lg:gap-2"
    routerLink="/pricing"
  >
    <span>{{
      'components.subscribeButton.actions.subscribe' | translate
    }}</span>
    <img
      class="h-6 w-6"
      ngSrc="/assets/icons/cart-add.svg"
      alt=""
      height="25"
      width="24"
    />
  </a>
} @else if (action() === 'manageSubscriptions') {
  <a
    class="btn-primary btn flex w-full gap-1 md:w-auto lg:gap-2"
    routerLink="/organization/subscriptions"
  >
    <span>{{
      'components.subscribeButton.actions.manageSubscriptions' | translate
    }}</span>
  </a>
} @else if (action() === 'manageSeats') {
  <a
    class="btn-primary btn flex w-full gap-1 md:w-auto lg:gap-2"
    routerLink="/organization/subscriptions"
  >
    <span>{{
      'components.subscribeButton.actions.manageSeats' | translate
    }}</span>
  </a>
} @else if (action() === 'unpaidInvoice') {
  <button
    class="md-w-auto btn flex w-full cursor-default gap-1 border-error-border bg-error-background text-error-text lg:gap-2"
    type="button"
    disabled
  >
    <span>{{ 'components.subscribeButton.unpaidInvoice' | translate }}</span>
  </button>
} @else if (action() === 'subscriptionNotStarted') {
  <button
    class="md-w-auto btn flex w-full cursor-default gap-1 border-error-border bg-error-background text-error-text lg:gap-2"
    type="button"
    disabled
  >
    <span>{{
      'components.subscribeButton.subscriptionNotStarted' | translate
    }}</span>
  </button>
} @else if (action() === 'requestAccess') {
  <button
    class="btn-secondary btn flex w-full items-center gap-2 sm:w-auto"
    (click)="requestSeatDialog.showModal()"
    type="button"
  >
    <span>{{ 'components.subscribeButton.requestAccess' | translate }}</span>
    <img class="h-5 w-5 shrink-0" src="/assets/icons/user_plus.svg" alt="" />
  </button>
} @else if (action() === 'subscribed') {
  <div
    class="md-w-auto btn flex w-full cursor-default gap-1 bg-ocean-blue-600 text-white lg:gap-2"
  >
    <span>{{ 'components.subscribeButton.subscribed' | translate }}</span>
  </div>
}

<dialog
  class="shadow-2xl fixed inset-0 z-50 m-auto max-h-[90vh] w-[calc(100%-2rem)] max-w-xl overflow-y-auto rounded-2xl border border-slate-200 bg-white p-0 text-slate-900 backdrop:bg-slate-950/50 backdrop:backdrop-blur-sm"
  #requestSeatDialog
>
  <div class="p-6 sm:p-8 lg:p-10">
    <div class="mb-6 max-w-lg">
      <h3 class="text-xl font-semibold tracking-tight sm:text-2xl">
        {{ 'components.subscribeButton.requestSeatDialog.request' | translate }}
      </h3>
      <p class="mt-3 max-w-prose text-sm leading-7 text-slate-600 sm:text-base">
        {{
          'components.subscribeButton.requestSeatDialog.description' | translate
        }}
      </p>
    </div>

    @if (isRequestSeatSuccess()) {
      <div
        class="mb-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800"
        role="status"
      >
        {{ 'components.subscribeButton.requestSeatDialog.success' | translate }}
      </div>
    }

    @if (isRequestSeatError()) {
      <div
        class="mb-4 rounded-lg border border-error-border bg-error-background px-4 py-3 text-sm text-error-text"
        role="alert"
      >
        {{ 'components.subscribeButton.requestSeatDialog.error' | translate }}
      </div>
    }

    <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
      <button
        class="btn w-full sm:w-auto"
        [disabled]="isRequestSeatPending()"
        (click)="requestSeatDialog.close()"
        type="button"
      >
        {{ 'components.subscribeButton.requestSeatDialog.dismiss' | translate }}
      </button>

      @if (!isRequestSeatSuccess()) {
        <button
          class="btn-primary btn w-full disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
          [disabled]="isRequestSeatPending()"
          (click)="requestSeat()"
          type="button"
        >
          @if (isRequestSeatPending()) {
            {{
              'components.subscribeButton.requestSeatDialog.requesting'
                | translate
            }}
          } @else {
            {{
              'components.subscribeButton.requestSeatDialog.request' | translate
            }}
          }
        </button>
      }
    </div>
  </div>
</dialog>
